<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-toast position="top-right"></p-toast>

    <registration-application-progress-v2 *ngIf="isVisibleRegistrationAppProgressModal"
                                       [_isVisibleRegistrationAppProgressModal]="isVisibleRegistrationAppProgressModal"
                                       [_riderId]="selectedRiderId"
                                       [_xpressUserId]="selectedXpressUserId"
                                       [_riderVehicleId]="selectedRiderVehicleId"
                                       [_riderVehicleServiceTypeId]="riderVehicleServiceTypeId"
                                       (changedVisibleRegistrationAppProgressEmit)="changedVisibleRegistrationAppProgressEmit($event)">
    </registration-application-progress-v2>

    <p-dialog [(visible)]="showLockDialog"
              [modal]="true"
              [style]="{width: '700px'}"
              [draggable]="false"
              [resizable]="false"
              styleClass="registration-lock-dialog">
        <div class="">
            <p class="dialog-head">Editing is blocked</p>
            <p class="dialog-subhead">{{lockDialogText}}</p>
        </div>
        <ng-template pTemplate="body">
            <div class="flex justify-content-center mt-1 h-35">
                <div type="button" (click)="showLockDialog = false" class="mt-3 text-center btn-view-vehicle btn-secondary cancel">Ok</div>
            </div>
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="showCreateApplicationModal"
              [modal]="true"
              [baseZIndex]="10000"
              [style]="{width: '560px', 'max-height': 'calc(100vh - 48px)'}"
              [contentStyle]="{'max-height': 'calc(100vh - 160px)', 'overflow-y': 'auto'}"
              [draggable]="false"
              [resizable]="false"
              [closable]="!isCreatingApplication"
              styleClass="create-application-dialog"
              (onHide)="closeCreateApplicationModal()">
        <ng-template pTemplate="header">
            <div class="create-app-dialog-title">Create Application</div>
        </ng-template>
        <div class="create-app-callout mb-3">
            Create an HQ-assisted application. It starts ready for verification and the workspace opens claimed for encoding.
        </div>

        <div class="create-app-section-title">Personal Information</div>
        <div class="field mb-3">
            <label>Full Name <span class="required">*</span></label>
            <input pInputText class="w-full" [(ngModel)]="createAppForm.fullName" placeholder="e.g. Juan Dela Cruz" />
            <small class="p-error" *ngIf="createAppErrors.fullName">{{createAppErrors.fullName}}</small>
        </div>
        <div class="field mb-3">
            <label>Mobile Number <span class="required">*</span></label>
            <div class="create-app-phone-row">
                <input pInputText class="create-app-phone-prefix" value="+63" readonly tabindex="-1" />
                <input pInputText class="create-app-phone-body"
                       [(ngModel)]="createAppForm.phone"
                       placeholder="912 345 6789"
                       maxlength="10"
                       (input)="onCreateAppPhoneInput('phone')" />
            </div>
            <small class="p-error" *ngIf="createAppErrors.phone">{{createAppErrors.phone}}</small>
        </div>
        <div class="field mb-3">
            <label>Date of Birth <span class="required">*</span></label>
            <p-calendar class="w-full create-app-calendar"
                        [(ngModel)]="createAppForm.birthDate"
                        [showIcon]="true"
                        appendTo="body"
                        dateFormat="yy-mm-dd"
                        [maxDate]="createAppMaxBirthDate"></p-calendar>
            <small class="p-error" *ngIf="createAppErrors.birthDate">{{createAppErrors.birthDate}}</small>
        </div>
        <div class="field mb-3">
            <label>Email Address <span class="required">*</span></label>
            <input pInputText class="w-full" [(ngModel)]="createAppForm.email" placeholder="Enter email address" />
            <small class="p-error" *ngIf="createAppErrors.email">{{createAppErrors.email}}</small>
        </div>
        <div class="field mb-3">
            <label>Full Address <span class="required">*</span></label>
            <input pInputText class="w-full" [(ngModel)]="createAppForm.address" placeholder="Enter full address" />
            <small class="p-error" *ngIf="createAppErrors.address">{{createAppErrors.address}}</small>
        </div>

        <div class="create-app-section-title">Emergency Contacts</div>
        <div class="field mb-3">
            <label>Emergency Contact Name <span class="required">*</span></label>
            <input pInputText class="w-full" [(ngModel)]="createAppForm.emergencyContactName" placeholder="Enter emergency contact name" />
            <small class="p-error" *ngIf="createAppErrors.emergencyContactName">{{createAppErrors.emergencyContactName}}</small>
        </div>
        <div class="field mb-3">
            <label>Emergency Contact Number <span class="required">*</span></label>
            <div class="create-app-phone-row">
                <input pInputText class="create-app-phone-prefix" value="+63" readonly tabindex="-1" />
                <input pInputText class="create-app-phone-body"
                       [(ngModel)]="createAppForm.emergencyContactPhone"
                       placeholder="912 345 6789"
                       maxlength="10"
                       (input)="onCreateAppPhoneInput('emergencyContactPhone')" />
            </div>
            <small class="p-error" *ngIf="createAppErrors.emergencyContactPhone">{{createAppErrors.emergencyContactPhone}}</small>
        </div>

        <div class="create-app-section-title">Service &amp; Classification</div>
        <div class="field mb-3">
            <label>Vehicle Type</label>
            <p-dropdown class="w-full" [options]="createAppVehicleOptions" optionLabel="label" optionValue="value"
                        [(ngModel)]="createAppForm.transportationType"
                        [disabled]="isTaxiLikeService(createAppForm.serviceTypeId)"
                        (onChange)="onCreateAppPathChanged()"></p-dropdown>
        </div>
        <div class="field mb-3" *ngIf="showCreateAppRide4WClassification">
            <label>Classification</label>
            <p-dropdown class="w-full" [options]="createAppRide4WVehicleOptions" optionLabel="label" optionValue="value"
                        [(ngModel)]="createAppForm.vehicleTypeId"></p-dropdown>
        </div>
        <div class="field mb-3">
            <label>Service / Path</label>
            <p-dropdown class="w-full" [options]="createAppServiceOptions" optionLabel="label" optionValue="value"
                        [(ngModel)]="createAppForm.serviceTypeId"
                        (onChange)="onCreateAppPathChanged()"></p-dropdown>
        </div>
        <div class="field mb-3">
            <label>EV Driver</label>
            <div class="create-app-salaried-row">
                <p-inputSwitch [(ngModel)]="createAppForm.isEVDriver"></p-inputSwitch>
                <span class="ml-2">{{ createAppForm.isEVDriver ? 'Yes' : 'No' }}</span>
            </div>
        </div>
        <div class="field mb-3 create-app-last-field">
            <label>Earning Type</label>
            <div class="create-app-salaried-row">
                <p-inputSwitch [(ngModel)]="createAppForm.isSalaried"
                               [disabled]="isTaxiLikeService(createAppForm.serviceTypeId)"></p-inputSwitch>
                <span class="ml-2">{{ createAppForm.isSalaried ? 'Salaried' : 'Non-salaried' }}</span>
                <span class="create-app-salaried-hint" *ngIf="isTaxiLikeService(createAppForm.serviceTypeId)">
                    Taxi / ConneX are always salaried
                </span>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <button pButton type="button" label="Cancel" class="p-button-outlined"
                    [disabled]="isCreatingApplication"
                    (click)="closeCreateApplicationModal()"></button>
            <button pButton type="button" label="Create &amp; Open"
                    [loading]="isCreatingApplication"
                    [disabled]="isCreatingApplication"
                    (click)="submitCreateApplication()"></button>
        </ng-template>
    </p-dialog>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="cards">
        <card *ngFor="let card of cards; let i = index;"
              [ngClass]="{'selected-step': selectedRegStep === card.RegistrationStep }"
              (click)="setStepFilter(card.RegistrationStep); getRegistrationRidersV2()"
              [header]="card.Header"
              [amount]="card.Amount"
              [iconPath]="card.IconPath">
        </card>
    </div>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="onboarding.Items"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="onboarding.Loading"
                 [paginator]="true"
                 [showFirstLastIcon]="false"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(71vh)'}"
                 [globalFilterFields]="['region']">
            <ng-template pTemplate="caption">
                <div class="flex flex-row justify-content-between align-items-center">
                    <div class="onboarding-registration-head-title title-float-left mt-2 pt-1">
                            {{headerTitleName}}
                    </div>
                    <div class="flex align-items-center">
                        <button *ngIf="canCreateApplication"
                                pButton
                                type="button"
                                label="Create Application"
                                class="p-button-sm mr-3"
                                (click)="openCreateApplicationModal()"></button>
                        <column-selector #columnSelector class="ml-3 mr-3 mt-1"
                             [defaultColumns]="defaultCols"
                             (selectedColumnsChange)="onSelectedColumnsChange($event)"
                             [tableName]="tableName"
                             [(selectedColumns)]="cols">
                        </column-selector>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.field !== 'Action'" [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <input type="number" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="onboardingHeaderSearch[filter.model]"
                                       (input)="onChangeHeaderFilter()" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="onboardingHeaderSearch[filter.model]"
                                       (input)="onChangeHeaderFilter()" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown && !filter.isObject">
                                <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                            optionLabel="name" optionValue="value" [(ngModel)]="onboardingHeaderSearch[filter.model]"
                                            (ngModelChange)="onChangeHeaderFilter()"></p-dropdown>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown && filter.isObject">
                                <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                            optionLabel="name" [(ngModel)]="onboardingHeaderSearch[filter.model]"
                                            (ngModelChange)="onChangeHeaderFilter()"></p-dropdown>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="onboardingHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy |"
                                            (ngModelChange)="onChangeHeaderFilter()" />
                            </ng-container>
                            <div *ngIf="filter.field === 'Action'" class="flex onbg-status-col action-btn" (click)="clearFilters()">
                                <div>Clear Filters</div>
                            </div>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rider>
                <tr [pSelectableRow]="rider">
                    <td class="ui-resizable-column" *ngFor="let item of cols" [ngClass]="{'cursor-pointer': selectedRegStep !== menuEnum.NeedsReview}"
                                    (click)="(selectedRegStep !== menuEnum.NeedsReview) ? openSideBar(rider) : $event.stopPropagation();">
                        <span class="onbg-status-col" *ngIf="item.field === 'Status'"
                              [style.background-color]="rider.StatusBgColor">{{rider.Status}}</span>
                        <div class="flex onbg-status-col action-btn cursor-pointer" *ngIf="item.field === 'Action'" (click)="startVerify(rider); $event.stopPropagation();">
                            <svg class="mt-1 mr-2" xmlns="http://www.w3.org/2000/svg" width="7" height="9" viewBox="0 0 7 9" fill="none">
                                <path d="M1.16667 2.12333L4.24083 4.08333L1.16667 6.04333V2.12333ZM0 0V8.16667L6.41667 4.08333L0 0Z" fill="white"/>
                            </svg>
                            <div>{{actionBtnTxt}}</div>
                        </div>

                        <span *ngIf="item.field !== 'Status' && item.field !== 'Action'">{{rider[item.field]}}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="onboarding.Items.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + onboarding.Items.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
